import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
    selector: 'app-text-area-input',
    templateUrl: './text-area-input.component.html',
    standalone: false
})
export class TextAreaInputComponent {

  @Input() formGroup : FormGroup
  @Input() id : string
  @Input() placeholder : string
  @Input() label : string
  @Input() maxLength : number
  @Input() value : string
  @Input() formError : string
  @Input() rows : number
  @Input() resizeable : boolean

  isFocused = false

}
